import { BANK_ACCOUNT_STATUS } from '../BankAccountsTable/constants'

export enum BANK_ACCOUNT_DETAILS_STATUS_REASONS {
  MICRO_DEPOSIT_EXPIRED = 'micro-deposit-expired',
  MICRO_DEPOSIT_RETURN = 'micro-deposit-return',
  MICRO_DEPOSIT_ATTEMPTS_EXCEEDED = 'micro-deposit-attempts-exceeded',
  MICRO_DEPOSIT_MAX_VERIFICATION_FAILURES = 'max-verification-failures',
  ADMIN_ACTION = 'admin-action',
  OTHER = 'other'
}

export const BANK_ACCOUNT_DETAILS_BANNER_TEXT = {
  [BANK_ACCOUNT_STATUS.VERIFICATION_FAILED]: {
    [BANK_ACCOUNT_DETAILS_STATUS_REASONS.MICRO_DEPOSIT_EXPIRED]: {
      text: 'Your verification window has expired.',
      subtext: 'Please restart the verification process.'
    },
    [BANK_ACCOUNT_DETAILS_STATUS_REASONS.MICRO_DEPOSIT_RETURN]: {
      text: 'Micro‑deposits were returned. Re‑verify the account by clicking “Retrigger sending deposits” (new micro‑deposits will be sent).',
      subtext: ''
    },
    [BANK_ACCOUNT_DETAILS_STATUS_REASONS.MICRO_DEPOSIT_ATTEMPTS_EXCEEDED]: {
      text: 'Micro‑deposits attempts exceeded. Re‑verify the account by clicking “Retrigger sending deposits” (new micro‑deposits will be sent)',
      subtext: ''
    }
  },
  [BANK_ACCOUNT_STATUS.ERRORED]: {
    [BANK_ACCOUNT_DETAILS_STATUS_REASONS.MICRO_DEPOSIT_EXPIRED]: {
      text: 'Your verification window has expired.',
      subtext: 'Please delete this bank account and link it again.'
    },
    [BANK_ACCOUNT_DETAILS_STATUS_REASONS.MICRO_DEPOSIT_RETURN]: {
      text: 'Micro-deposits were returned. The account is invalid or unusable. Please add a new bank account',
      subtext: ''
    },
    [BANK_ACCOUNT_DETAILS_STATUS_REASONS.MICRO_DEPOSIT_MAX_VERIFICATION_FAILURES]:
      {
        text: 'Maximum verification failures reached. Please delete this bank account and add a new bank account',
        subtext: ''
      }
  }
}

export const BANK_ACCOUNT_DETAILS_BANNER_OTHER = {
  BANK_ACCOUNT_DETAILS_STATUS_REASONS_OTHER: {
    text: 'An unexpected issue occurred with this bank account. You may delete this account or contact support for assistance.',
    subtext: ''
  },
  BANK_ACCOUNT_DETAILS_STATUS_REASONS_ADMIN_ACTION: {
    text: 'This account was marked by an administrative action. Please contact support or delete the account',
    subtext: ''
  },
  BANK_ACCOUNT_DETAILS_STATUS_CREATED: {
    text: 'Verify bank account',
    subtext:
      'This account is currently inactive. Please, click Send deposits to initiate the verification process. The deposits will appear in your account within 3–5 business days.'
  }
}

export enum ACCOUNT_PURPOSE_OPTIONS {
  PAYABLE = 'payable',
  RECEIVABLE = 'receivable'
}

export const ACCOUNT_PURPOSE_OPTIONS_FULL_LABELS = {
  [ACCOUNT_PURPOSE_OPTIONS.PAYABLE]: 'Account payable (AP)',
  [ACCOUNT_PURPOSE_OPTIONS.RECEIVABLE]: 'Account receivable (AR)'
}

export const ACCOUNT_PURPOSE_OPTIONS_LABELS = {
  [ACCOUNT_PURPOSE_OPTIONS.PAYABLE]: 'Payable',
  [ACCOUNT_PURPOSE_OPTIONS.RECEIVABLE]: 'Receivable'
}

export const ACCOUNT_PURPOSE_OPTIONS_DESCRIPTIONS = {
  [ACCOUNT_PURPOSE_OPTIONS.PAYABLE]:
    'Authorize and make payments or disbursements from this account. I confirm there is no debit block on this account.',
  [ACCOUNT_PURPOSE_OPTIONS.RECEIVABLE]:
    'Receive payments and payouts for this account.'
}
